


























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Popup, Cell, CellGroup, NoticeBar, Collapse, CollapseItem, Tab, Tabs, ActionSheet, Overlay, Step, Steps } from "vant";
import workService from "../../service/workService";
import { WorkTaskModel, WorkTaskEntity } from "../../model/Work";
import { BusinessType, categoryMap, ServiceType, Categorys, DutyCode, DealStatus, ActiveStatus } from "../../model/Base";
import { OrderEntity } from "../../model/Order";
import _ from "lodash";
import enumUtils from "../../utils/enumUtils";
import hotelService from "../../service/hotelService";
import flightService from "../../service/flightService";
import trainService from "../../service/trainService";
import logsService from "../../service/logsService";
import { LogInfoEntity } from "../../model/Logs";
import { BtripTaskEntity } from "../../model/Btrip";
import moment from "moment";
import { HotelProductEntity } from "../../model/hotel";
import { DurationTime } from "@/utils/utils.ts";
import flightOrderInfo from "@/views/order/flight/flightOrderInfo.vue";
import hotelOrderInfo from "@/views/order/hotel/hotelOrderInfo.vue";
import trainOrderInfo from "@/views/order/train/trainOrderInfo.vue";
import trafficOrderInfo from "@/views/order/traffic/trafficOrderInfo.vue";
import trafficService from "@/service/trafficService";
import SystemService from "@/service/UserService";
import { filterFeatureCodes } from "./orderUtils";
@Component({
  name: "orderDetail",
  components: {
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [ActionSheet.name]: ActionSheet,
    [Overlay.name]: Overlay,
    [Step.name]: Step,
    [Steps.name]: Steps,
    flightOrderInfo,
    hotelOrderInfo,
    trainOrderInfo,
    trafficOrderInfo,
  },
  filters: {
    hrefURL(value: string) {
      return value.indexOf('http') == 0 ? value : '/api/side/Storage/Index/Raw/' + value;
    },
    showTime(value: string) {
      return value.substr(11, 5);
    },
    showDateWeek(value: string) {
      let date = moment(value);
      let weeks: any = {
        0: this.$root.$t("order_orderdetails_ri") as string,
        1: this.$root.$t("order_orderdetails_yi") as string,
        2: this.$root.$t("order_orderdetails_er") as string,
        3: this.$root.$t("order_orderdetails_san") as string,
        4: this.$root.$t("order_orderdetails_si") as string,
        5: this.$root.$t("order_orderdetails_wu") as string,
        6: this.$root.$t("order_orderdetails_liu") as string,
      };
      let week = weeks[date.day()];
      return `${date.format("MM.DD")} (${this.$root.$t("order_orderdetails_zhou") as string}${week} )`;
    },
    showDateTime(value: string) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
    showConsumerName(value: string) {
      let index = value.indexOf(",");
      return index > 0 ? value.substr(0, index) + "..." : value;
    },
    DurationTime,
  },
})
export default class orderDetails extends Vue {
  //data
  showDetail = false;
  comName: string = "";
  active = 1;
  pdtRules = [];
  showLogs = false;
  featureCodes: string = "";
  //computed
  get ServeType() {
    // return this.$route.query.ServeType;
    return this.order.ServiceType + "";
  }
  get orderStatus() {
    return this.$route.query.orderStatus;
  }
  get isShowConsumer() {
    return this.order.ServiceType != ServiceType.TrafficService;
  }

  // 获取附件列表
  get attachmentList() {
    let result = [];
    if (this.order.ExtraInfos && this.order.ExtraInfos.length > 0) {
      result = this.order.ExtraInfos.filter((item: any) => item.ExtraCode === "order_attachment");
    }
    return result;
  }
  filterExtraData(data: string) {
    let datas = data.split('/')
    return datas.splice(datas.length - 1, 1).join('')
  }
  getSalesPrice(Goods?: any) {
    let result = {
      PriceName: "",
      SalesPrice: 0,
      PriceType: "",
    };
    let SumPrice = 0;
    _.forEach(Goods.Prices, o => {
      if (o.PriceType == 1672 || o.PriceType == 1660) {
        result.PriceType = o.PriceType;
        result.PriceName = o.PriceName;
      }
      if (o.PriceType == 1672 || o.PriceType == 1660 || o.PriceType == 1692) {
        SumPrice += o.SalesPrice;
      }
    });
    result.SalesPrice = SumPrice;
    return result;
  }

  //mounted
  mounted() {
    (window as any).detail = this;
    this.loadData().then(() => {
      _.forEach(this.Services, item => {
        if (item.value == this.ServeType) {
          this.comName = item.code.toLowerCase().replace("service", "OrderInfo");
        }
      });
    });
    this.getBtripExtra()
  }
  get OrderID() {
    let query = this.$route.query;
    return query.OrderID || query.OrderId || query.orderId;
  }
  tasks: WorkTaskModel[] = [];
  order: any = {};

  get ServiceTypes() {
    return enumUtils.makeArray(Categorys.ServiceType);
  }

  get Services() {
    return _.filter(this.ServiceTypes, o => o.value == 1409 || o.value == 1407 || o.value == 1470 || o.value == 1408 || o.value == 1555);
  }
  diffDays(DepartDate: string, ArrivalDate: string) {
    let ArrivalTimes = moment(ArrivalDate);
    let DepartTimes = moment(DepartDate);
    return ArrivalTimes.diff(DepartTimes, "days");
  }
  loadData() {
    let __self = this;
    let where: any = { WorkID: __self.OrderID, Props: "BusinessInfo" };
    return workService.getWorkTasks(where).then(function (json) {
      if (!json.isSucc) {
        return;
      }
      let order = {};
      let tasks = json.result as any;
      for (let i = 0; i < tasks.length; i++) {
        var data = tasks[i];
        let result = _.find(__self.Services, o => o.value == data.ServiceType);

        if (result && data.BusinessType == BusinessType.Sales) {
          __self.SearchOrders(data.UniqueID, result.code, data.ServiceType);
          order = _.cloneDeep(data.BusinessInfo);
        }
      }
      __self.tasks = tasks;
      __self.order = order;
      let str = filterFeatureCodes(__self.order.FeatureCodes, __self.order.ServiceType, __self.order);
      let langArr = [
        { id: __self.$root.$t("order_orderdetails_yiwancheng"), text: "已完成" },
        { id: __self.$root.$t("order_orderdetails_yiquxiao"), text: "已取消" },
        { id: __self.$root.$t("order_orderdetails_yituihui"), text: "已退回" },
        { id: __self.$root.$t("order_orderdetails_daishenpi"), text: "待审批" },
        { id: __self.$root.$t("order_orderdetails_daichuli"), text: "待处理" },
        { id: __self.$root.$t("order_orderdetails_daiqueren"), text: "待确认" },
        { id: __self.$root.$t("order_orderdetails_tuifangchulizhong"), text: "退房处理中" },
        { id: __self.$root.$t("order_orderdetails_tuituanchulizhong"), text: "退团处理中" },
        { id: __self.$root.$t("order_orderdetails_tuipiaochulizhong"), text: "退票处理中" },
        { id: __self.$root.$t("order_orderdetails_youtuifang"), text: "有退房" },
        { id: __self.$root.$t("order_orderdetails_youtuituan"), text: "有退团" },
        { id: __self.$root.$t("order_orderdetails_youtuipiao"), text: "有退票" },
        { id: __self.$root.$t("order_orderdetails_gaiqianchulizhong"), text: "改签处理中" },
        { id: __self.$root.$t("order_orderdetails_yougaiqian"), text: "有改签" },
        { id: __self.$root.$t("order_orderdetails_quanbugaiqianzhong"), text: "全部改签中" },
        { id: __self.$root.$t("order_orderdetails_quanbutuifangzhong"), text: "全部退房中" },
        { id: __self.$root.$t("order_orderdetails_quanbutuipiaozhong"), text: "全部退票中" },
        { id: __self.$root.$t("order_orderdetails_quanbugaiqian"), text: "全部改签" },
        { id: __self.$root.$t("order_orderdetails_quanbutuifang"), text: "全部退房" },
        { id: __self.$root.$t("order_orderdetails_quanbutuipiao"), text: "全部退票" },
      ];
      _.forEach(langArr, (item: any) => {
        str = str.replace(item.text, item.id);
      });
      __self.featureCodes = str;
      __self.loadLogs();
    });
  }
  setShowLogs() {
    this.showLogs = false;
  }
  IsChangeOrRefunds = [];
  SearchOrders(UniqueID: string, ServiceCode: string, ServeType: number) {
    let __self = this;
    let serviceCtl = null;
    if (ServeType == ServiceType.FlightService) {
      serviceCtl = flightService.SearchOrders(UniqueID);
    } else if (ServeType == ServiceType.HotelService) {
      serviceCtl = hotelService.SearchOrders(UniqueID);
    } else if (ServeType == ServiceType.TrafficService) {
      serviceCtl = trafficService.SearchOrders(UniqueID);
    } else {
      serviceCtl = trainService.SearchOrders(UniqueID);
    }
    serviceCtl.then(json => {
      if (json.isSucc) {
        __self.IsChangeOrRefunds = __self.IsChangeOrRefunds.concat(json.result);
      }
    });
  }

  get BusinessTypes() {
    return enumUtils.makeArray(Categorys.BusinessType);
  }

  get taskGroups() {
    return _.groupBy(this.salesTasks, o => o.BusinessInfo.OriginID);
  }

  get amendTasks(): WorkTaskEntity[] {
    return _.filter(this.mainTasks, o => o.BusinessCode == "Amend");
  }

  get salesTasks(): WorkTaskEntity[] {
    return _.filter(this.mainTasks, o => o.BusinessCode != "Amend");
  }
  get mainTasks() {
    let serviceCodes = ["Charge", "Insurance", "Bill"];
    let tasks = _.filter(this.tasks, o => _.find(this.BusinessTypes, m => m.code == o.BusinessCode) && serviceCodes.indexOf(o.ServiceCode!) == -1 && o.FlowCode != "Bill");
    return _.orderBy(tasks, o => o.TaskID);
  }

  get OrderList() {
    let list = _.cloneDeep(this.tasks);
    let businessType: any = {
      CategoryID: 153,
      Change: 1789,
      Sales: 1797,
      Product: 1795,
      Amend: 1799,
      Bill: 1791,
      Invoice: 1792,
      Company: 1793,
      People: 1801,
    };
    let lists = _.orderBy(
      _.remove(list, (item: any) => businessType[item.BusinessCode] && item.ServiceCode != "Charge" && item.ServiceCode != "Insurance" && item.FlowCode != "Bill"),
      item => item.TaskID
    );
    return lists;
  }

  logs: LogInfoEntity[] = [];
  loadLogs() {
    this.logs = [];
    _.forEach(this.OrderList, item => {
      let id = item.UniqueID;
      let data = {
        TargetID: id,
        PageSize: 99999,
      };
      logsService.getLogs(data).then((res: any) => {
        if (res.isSucc) {
          const { entities } = res.result;
          _.forEach(entities, item => {
            this.logs.push(item);
          });
          this.logs = _.reverse(_.orderBy(this.logs, "CreateTime", "desc"));
        }
      });
    });
  }

  get TradeInfos() {
    let __self = this;
    let list: any = {
      CenterNames: [],
      ProjectCodes: [],
      IntentNames: [],
      WorkTask: [],
      RejectReasons: [],
      Contrarys: [],
      WorkTaskStatus: [],
    };
    if (JSON.stringify(__self.taskGroups) == "{}") {
      return list;
    }
    let taskGroups = __self.taskGroups as any;
    for (const key in taskGroups) {
      if (__self.taskGroups.hasOwnProperty(key)) {
        let orderGroup = taskGroups[key];
        for (let i = 0; i < orderGroup.length; i++) {
          let order = orderGroup[i];
          let data = _.find(__self.tasks, o => o.UnionID == order.UnionID && o.FlowCode == "Btrip");
          if (!data) {
            return list;
          }
          let BusinessInfo = data.BusinessInfo as BtripTaskEntity;
          list.CenterNames.push(BusinessInfo.CenterName);
          list.ProjectCodes.push(BusinessInfo.ProjectCode);
          list.IntentNames.push(BusinessInfo.IntentName);
          list.RejectReasons.push(BusinessInfo.RejectReason);

          ["CenterNames", "ProjectCodes", "IntentNames", "RejectReasons"].forEach(o => (list[o] = _.uniq(list[o])));
          // list.CenterNames = _.uniq(list.CenterNames);
          // list.ProjectCodes = _.uniq(list.ProjectCodes);
          // list.IntentNames = _.uniq(list.IntentNames);
          // list.RejectReasons = _.uniq(list.RejectReasons);

          let Contrary: any = {
            CauseNames: [],
            ContraryInfos: [],
            CauseDetails: [],
            ViolationPolicys: [],
          };
          let Contrarys = BusinessInfo.Contrarys as any[];
          if (Contrarys.length > 0) {
            Contrarys.forEach(o => {
              let ViolationPolicy = {
                ProductName: o.ProductName,
                ContraryInfo: o.ContraryInfo,
                RefContrary: o.RefContrary,
              };
              Contrary.CauseNames.push(o.CauseName);
              Contrary.CauseNames = _.uniq(Contrary.CauseNames);
              Contrary.ContraryInfos.push(o.ContraryInfo);
              Contrary.ContraryInfos = _.uniq(Contrary.ContraryInfos);
              Contrary.CauseDetails.push(o.CauseDetails);
              Contrary.CauseDetails = _.uniq(Contrary.CauseDetails);
              Contrary.ViolationPolicys.push(ViolationPolicy);
            });
            list.Contrarys.push(Contrary);
          }
          let status = __self.TaskStatus(data);
          list.WorkTask.push(data);
          list.WorkTaskStatus.push(status);
          list.WorkTaskStatus = _.uniq(list.WorkTaskStatus);
        }
      }
    }
    return list;
  }
  get ActiveStatus() {
    return enumUtils.makeArray(Categorys.ActiveStatus);
  }
  TaskStatus(WorkTask: WorkTaskEntity) {
    let __self = this;
    let status = null;
    let Datas = [];
    let Acitves = _.filter(WorkTask.Actives, o => o.NodeID == WorkTask.ActiveNode && o.DutyCode == DutyCode.Executer);
    if (Acitves.length > 0) {
      Acitves.forEach(o => {
        let result = o.ActiveUserName;
        if (o.ActiveUserName == "") {
          result = o.ActiveUserID;
        }
        Datas.push(result);
      });
    } else {
      let result = WorkTask.ActiveUserName;
      if (WorkTask.ActiveUserName == "") {
        result = WorkTask.ActiveUserID;
      }
      Datas.push(result);
    }
    if (WorkTask.TaskStatus == ActiveStatus.WaitDispose) {
      status = __self.$t("mall.Wait") + `[${Datas}]` + __self.$t("mall.Approval");
    } else {
      let Status = _.find(__self.ActiveStatus, o => o.value == WorkTask.TaskStatus);
      if (Status) {
        status = Status.CategoryTitle;
      }
    }
    return status;
  }

  get ChargePrice() {
    let data = _.find(this.tasks, o => o.FlowCode == "Charge");
    if (data) {
      return data.BusinessInfo.ReceiveAmount;
    }
    return 0;
  }
  get InsurancePrice() {
    let data = _.find(this.tasks, o => o.FlowCode == "Insurance");
    if (data) {
      return data.BusinessInfo.ReceiveAmount;
    }
    return 0;
  }

  //activated
  activated() { }

  //methods
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  back() {
    history.back();
    // this.$router.push("/order/list");
  }
  // filterFeatureCodes(featurecode: string, orderServiceType: number, item: any) {
  // console.log("1:" + featurecode, "2:" + orderServiceType, "3:" + item);
  // return filterFeatureCodes(featurecode, orderServiceType, item);
  // }
  getReceiveAmount(tasks: any) {
    let totalPrice: number = 0;
    _.forEach(tasks, task => {
      _.forEach(task, item => {
        totalPrice += parseInt(item.BusinessInfo.ReceiveAmount);
      });
    });
    return totalPrice;
  }
  call() {
    window.location.href = "tel://400-088-8020";
  }
  btripConfigInfo = '';
  getBtripExtra(){     
     let __self=this;
     let data = {
      ExtraCode:'company.Btrip',
      MasterID:__self.profile.CompanyID || ''
     };
     SystemService.getCompanyExtra(data).then(p=>{
       if(p.isSucc){
          const btrip=p.result;
          if(btrip && btrip.ExtraCode === 'company.Btrip'){
          if(btrip.ExtraData){
             __self.btripConfigInfo=btrip.ExtraData;
          }else{
             __self.btripConfigInfo=btrip.ExtraData;
          }
          }
       }
     })
  }
  showBtripItem(key: string) {
    return this.btripConfigInfo.includes(key);
  }

}
